import { useRef, useState } from "react";
import { Upload } from "lucide-react";
import { toast } from "sonner";
import api, { fmtErr } from "@/lib/api";

export default function ImageField({ value, onChange, testPrefix }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (e) => {
    const file = (e.target.files || [])[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/uploads/image", fd);
      onChange(data.url);
      toast.success("Image uploaded.");
    } catch (err) {
      toast.error(fmtErr(err));
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const previewSrc = value && value.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${value}` : value;

  return (
    <div className="sm:col-span-2">
      <label className="overline-label !text-[10px] block mb-1">Image — paste a link or upload</label>
      <div className="flex items-center gap-3">
        <input data-testid={`${testPrefix}-image-url`} value={value} onChange={(e) => onChange(e.target.value)} className="field flex-1" placeholder="https://…" />
        <button type="button" data-testid={`${testPrefix}-image-upload`} onClick={() => inputRef.current?.click()} disabled={busy} className="btn-outline !px-4 !py-2.5 shrink-0 disabled:opacity-40">
          <Upload size={14} /> {busy ? "Uploading…" : "Upload"}
        </button>
        <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={upload} data-testid={`${testPrefix}-image-file`} />
      </div>
      {value && (
        <img src={previewSrc} alt="Casting image preview" className="mt-4 h-24 w-40 object-cover border border-white/10" data-testid={`${testPrefix}-image-preview`} />
      )}
    </div>
  );
}
